import { action } from "typesafe-actions";
import { PayActionTypes } from "./types";

// 查询发放列表
export const fetchPayList = (params: any) => action(
  PayActionTypes.FETCH_QUERY_PAY_LIST,
  params
);
export const fetchPayListFinish = (data: object) => action (
  PayActionTypes.FETCH_QUERY_PAY_LIST_FINISH,
  data
);

// loading
export const fetchLoading = (data: any) => action(
  PayActionTypes.FETCH_LOADING,
  data
)

// 创建发放时获取批次号
export const fetchPayBatch = () => action(
  PayActionTypes.FETCH_QUERY_BATCH
)

// 查询是否有名单模板
export const fetchTempUrl = (data: object) => action(
  PayActionTypes.FETCH_QUERY_TEMP_URL,
  data
)

// 下载模板
export const fetchDownLoadTemp = (data: any) => action(
  PayActionTypes.FETCH_DOWNLOAD_TEMP,
  data
)

// onePay字段赋值
export const fetchOnePayFinish = (data: object) => action(
  PayActionTypes.FETCH_QUERY_ONEPAY_FINISH,
  data
)

// 确认发放、撤销发放、保存凭证
export const fetchCommon = (data: any) => action(
  PayActionTypes.FETCH_COMMON,
  data
)

// 创建发放
export const fetchApplyPay = (data: any) => action(
  PayActionTypes.FETCH_APPLY_PAY,
  data
)

// 查询状态下拉列表
export const fetchStatusList = (data: any) => action(
  PayActionTypes.FETCH_STATUS_LIST,
  data
)
export const fetchStatusListFinish = (data: any) => action(
  PayActionTypes.FETCH_STATUS_LIST_FINISH,
  data
)

// 查看凭证
export const fetchQueryImage = (data: any) => action(
  PayActionTypes.FETCH_QUERY_IMAGE,
  data
)

// 导出获取taskId
export const fetchExportExcel = (data: any) => action(
  PayActionTypes.FETCH_EXPORT_EXCEL,
  data
)

// 根据taskId轮询导出excel
export const fetchExportByTaskId = (taskId: any) => action(
  PayActionTypes.FETCH_EXPORT_BY_TASKID,
  taskId
)
export const fetchExportByTaskIdFinish = (data: any) => action(
  PayActionTypes.FETCH_EXPORT_BY_TASKID_FINISH,
  data
)

// 点击放大图片
export const fetchShowPic = (bool: boolean) => action(
  PayActionTypes.FETCH_SHOW_PIC,
  bool
)



// WEBPACK FOOTER //
// ./src/store/pay/actions.ts